import { ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ButtonAlignment, KeyValuePair, PartnerButton, PartnerButtonStore, PartnerPageVersion, ButtonSize } from '@fitscovery/partner/data-access';
import { WINDOW } from '@ng-web-apis/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
	selector: 'fitscovery-ui-custom-button',
	templateUrl: './ui-custom-button.component.html',
	styleUrls: ['./ui-custom-button.component.scss']
})
export class UiCustomButtonComponent implements OnInit, OnDestroy {
	@Input() homePageVersion: PartnerPageVersion;
	@Input() button: PartnerButton;
	@Input() email: string;
	showButton: boolean;
	isLinkInternal: boolean;
	alignment: ButtonAlignment;
	size: ButtonSize;

	style: PartnerPageVersion;
	text: string;
	textColor: string;
	url: string;
	color: string;

	buttonAlignment: string;
	buttonSize: string;
	buttonStyle: string;
	buttonClasses: string[];

	private alignmentStyle: KeyValuePair[];
	private sizeClasses: KeyValuePair[];
	private styleClasses: KeyValuePair[];

	private subscription$: Subject<boolean> = new Subject<boolean>();

	constructor(
		@Inject(WINDOW) private window: any,
		private changeDetectRef: ChangeDetectorRef,
		private buttonStore: PartnerButtonStore) {
	}

	ngOnInit(): void {
		this.text = '';
		this.textColor = '';
		this.url = '';
		this.color = '';
		this.buttonStyle = '';
		this.buttonClasses = [];
		this.renderButton();
	}

	ngOnDestroy(): void {
		this.subscription$.complete();
	}

	navigateByUrl(url: string): void {
		url = url.indexOf('http') < 0 ? `https://${url}` : url;
		this.window.open(url);
	}

	private getSizeClasses(): KeyValuePair[] {
		const array: KeyValuePair[] = [{
			key: ButtonSize.Small,
			value: 'button-sm'
		}, {
			key: ButtonSize.Medium,
			value: 'button-md'
		}, {
			key: ButtonSize.Large,
			value: 'button-lg'
		}, {
			key: ButtonSize.ExtraLarge,
			value: 'button-xl'
		}];

		return array;
	}

	private getAlignmentStyles(): KeyValuePair[] {
		const array: KeyValuePair[] = [{
			key: ButtonAlignment.Left,
			value: 'left'
		}, {
			key: ButtonAlignment.Center,
			value: 'center'
		}, {
			key: ButtonAlignment.Right,
			value: 'right'
		}];

		return array;
	}

	private getStyleClasses(): KeyValuePair[] {
		const buttonClass = 'btn-homepage';
		const array: KeyValuePair[] = [{
			key: PartnerPageVersion.Preview,
			value: buttonClass + '--default'
		}, {
			key: PartnerPageVersion.Version1,
			value: buttonClass + '--default'
		}, {
			key: PartnerPageVersion.Version2,
			value: buttonClass + '--default'
		}, {
			key: PartnerPageVersion.Version3Dark,
			value: buttonClass + '--groove'
		}, {
			key: PartnerPageVersion.Version3Light,
			value: buttonClass + '--groove'
		}
	];

		return array;
	}

	private mapButton(button: PartnerButton): void {
		this.showButton = button?.showButton!;
		this.isLinkInternal = button?.isLinkInternal!;
		this.alignment = (<ButtonAlignment>button?.alignment);
		this.size = (<ButtonSize>button?.size);
		this.style = this.homePageVersion;
		this.text = button?.text ? button?.text : 'Text here.';
		this.textColor = button?.textColor!;
		this.url = button?.url!;
		this.color = button?.color!;
	}

	private async renderButton(): Promise<void> {
		await this.buttonStore.addPartnerButton(this.button, false);
		this.buttonStore.partnerButtons$.pipe(
			takeUntil(this.subscription$)
		).subscribe((buttons: PartnerButton[]) => {
			const button = buttons.find(pb => pb.id === this.button?.id);
			this.mapButton(button!);
			this.renderButtonStyles();
			this.changeDetectRef.markForCheck();
		});

	}

	private renderButtonStyles() {
		this.alignmentStyle = this.getAlignmentStyles();
		this.sizeClasses = this.getSizeClasses();
		this.styleClasses = this.getStyleClasses();
		this.buttonAlignment = this.alignmentStyle[this.alignment]?.value;
		this.buttonSize = this.sizeClasses[this.size]?.value;
		this.buttonStyle = this.styleClasses[this.style]?.value;
		this.buttonClasses.push(this.buttonSize, this.buttonStyle);
	}
}
